import { render, staticRenderFns } from "./SBLoading.html?vue&type=template&id=57031bce&scoped=true&"
import script from "./SBLoading.ts?vue&type=script&lang=ts&"
export * from "./SBLoading.ts?vue&type=script&lang=ts&"
import style0 from "./SBLoading.css?vue&type=style&index=0&id=57031bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57031bce",
  null
  
)

export default component.exports